import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

interface FormlyBannerProps {
  fields: Array<{ label: string; value: string | number }>;
}

@Component({
  selector: 'formly-banner',
  imports: [],
  template: `
    <div class="banner">
      @for (field of to.fields; track field) {
        <div class="banner-item" style="flex: 1; text-align: left; margin: 10 10px;">
          <span class="banner-label">{{ field.label }}</span>
          <span class="banner-value">{{ field.value }}</span>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .banner {
        background-color: #f0f0f0;
        height: 83px;
        display: flex;
        align-items: center;
        padding: 10px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        width: 100%;
      }
      .banner-label {
        display: block;
        font-weight: bold;
        color: #141414;
        font-size: 16px;
        margin-bottom: 4px;
      }
      .banner-value {
        display: block;
        font-size: 16px;
        color: #141414;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyBannerComponent extends FieldType<FieldTypeConfig<FormlyBannerProps>> {}
